import { useQuery, useMutation } from "./urqlHooks";

const CASHFLOW_AREAS = `
query CASHFLOW_AREAS($companyId: String!) {
	allCashflowAreas(companyId: $companyId) {
		id
		name
		category
	}
}
`;

export const GetCashFlowAreasData = ({ companyId }) => {
  const [result, reexecuteQuery] = useQuery({
    query: CASHFLOW_AREAS,
    variables: { companyId },
    pause: !companyId || companyId === null || companyId === undefined, // Skip query when no companyId is provided
  });
  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const CREATE_CASHFLOW_AREA = `
mutation CREATE_NEW_AREA($companyId: String!, $name: String!, $category: String!) {
  createNewCashflowArea(
    companyId: $companyId,
    name: $name,
    category: $category,
  ) {
      status
      message
      data
  }
}
`;

export const CreateCashFlowArea = () => {
  const [updated, reexecuteMutation] = useMutation(CREATE_CASHFLOW_AREA);
  const {data, fetching, error} = updated
  return { data, fetching, error, reexecuteMutation };
};

const CREATE_CASHFLOW_CATEGORY = `
mutation CREATE_CASHFLOW_CATEGORY($companyId: String!, $name: String!, $isIncome: Boolean!) {
  createNewCashflowCategory(
    companyId: $companyId,
    name: $name,
    isIncome: $isIncome,
  ) {
      status
      message
      data
  }
}
`;

export const CreateCashflowCategory = () => {
  const [result, reexecuteMutation] = useMutation(CREATE_CASHFLOW_CATEGORY);
  const {data, fetching, error} = result
  return { data, fetching, error, reexecuteMutation };
};

const GET_CASHFLOW_CATEGORIES = `
query GET_CASHFLOW_CATEGORIES($companyId: String!) {
  findCashflowCategories(
    companyId: $companyId,
  ) {
    id,
    categories {
      id,
      name,
      category,
      isIncome
    }
  }
}
`;

export const GetCashflowCategories = ({ companyId }) => {
  const [result, reexecuteQuery] = useQuery({
    query: GET_CASHFLOW_CATEGORIES,
    variables: { companyId },
    pause: !companyId || companyId === null || companyId === undefined, // Skip query when no companyId is provided
  });

  const { data, fetching, error } = result;
  return { data, fetching, error, reexecuteQuery };
};

const UPDATE_CASHFLOW_AREA = `
mutation UPDATE_CASHFLOW_AREA($companyId: String!, $name: String!, $cashflowAreaId: String!, $category: String!) {
  updateCashflowArea(
    companyId: $companyId,
    name: $name,
    cashflowAreaId: $cashflowAreaId,
    category: $category,
  ) 
}
`;

export const UpdateCashflowArea = () => {
  const [result, reexecuteMutation] = useMutation(UPDATE_CASHFLOW_AREA);
  return { result, reexecuteMutation };
};

const UPDATE_CASHFLOW_CATEGORY = `
mutation UPDATE_CASHFLOW_CATEGORY($companyId: String!, $name: String!, $categoryId: String!) {
  updateCategory(
    companyId: $companyId,
    name: $name,
    categoryId: $categoryId,
  ) 
}
`;

export const UpdateCashflowCategory = () => {
  const [result, reexecuteMutation] = useMutation(UPDATE_CASHFLOW_CATEGORY);
  return { result, reexecuteMutation };
};

const DELETE_CASHFLOW_AREA = `
mutation DELETE_CASHFLOW_AREA($companyId: String!, $cashflowAreaId: String!) {
  deleteArea(
    companyId: $companyId,
    cashflowAreaId: $cashflowAreaId,
  )
  
}
`;

export const DeleteCashflowArea = () => {
  const [result, reexecuteMutation] = useMutation(DELETE_CASHFLOW_AREA);
  return { result, reexecuteMutation };
};

const DELETE_CASHFLOW_AREA_WITHOUT_FIELDS = `
mutation DELETE_CASHFLOW_AREA($companyId: String!, $cashflowAreaId: String!, $income : Boolean!, $category: String!) {
  deleteArea(
    companyId: $companyId,
    cashflowAreaId: $cashflowAreaId,
  )
  deleteFlowArea(
    companyId: $companyId,
    income : $income,
    cashflowCategoryId : $category,
    cashflowAreaId: $cashflowAreaId,

  ) {
    status
    message
    data
  }
}`;

export const DeleteCashflowAreaWithoutFields = () => {
  const [result, reexecuteMutation] = useMutation(DELETE_CASHFLOW_AREA_WITHOUT_FIELDS);
  return { result, reexecuteMutation };
}

const UPDATE_FLOW_AREA_ID =`
mutation UPDATE_FLOW_AREA_ID(
  $oldCashflowAreaId: String!,
  $newCashflowAreaId: String!,
  $companyId: String!,
  $income : Boolean!,
  $category: String!, 
  ) {
    updateCashflowAreaId(
      oldCashflowAreaId: $oldCashflowAreaId,
      newCashflowAreaId: $newCashflowAreaId,
      companyId: $companyId,
    )
    deleteArea(
      companyId: $companyId,
      cashflowAreaId: $oldCashflowAreaId,
    )
    deleteFlowArea(
      companyId: $companyId,
      income : $income,
      cashflowCategoryId : $category,
      cashflowAreaId: $oldCashflowAreaId,

    ) {
      status
      message
      data
    }
    
    
  }`


export const UpdateCashflowAreaId = () => {
  const [result, reexecuteMutation] = useMutation(UPDATE_FLOW_AREA_ID);
  return { result, reexecuteMutation };
}


const DELETE_CASHFLOW_CATEGORY = `
mutation DELETE_CASHFLOW_CATEGORY($companyId: String!, $cashflowCategoryId: String!, $cashflowCategoryName: String!) {
  deleteCategory(
    companyId: $companyId,
    cashflowCategoryId: $cashflowCategoryId,
    cashflowCategoryName: $cashflowCategoryName
  ) 
}
`;

export const DeleteCashflowCategory = () => {
  const [result, reexecuteMutation] = useMutation(DELETE_CASHFLOW_CATEGORY);
  return { result, reexecuteMutation };
};

const EXCEL_PROJECTIONS = `mutation GET_EXCEL_PROJECTIONS($companyId: String!, $name: String, $id: String) {
  generateProjectionExcel(companyId: $companyId, name: $name, id: $id)
}`

export const GetExcelProjections = () => {
  const [result, reexecuteMutation] = useMutation(EXCEL_PROJECTIONS);
  return { result, reexecuteMutation };
};